import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminNotificationsPage from '../../../subsreens/gcadmin/adminnotificationpage/AdminNotificationsPage';


const AdminNotification = () => {
    return(
        <AdminMasterLayout>
            <AdminNotificationsPage></AdminNotificationsPage>
        </AdminMasterLayout>
    )
}

export default AdminNotification;